import { takeLatest, put, delay } from 'redux-saga/effects';


import * as TYPES from '../actions/types';
import {  loaderAction,  saveClientAppointments,  saveClientDiagnosis} from '../actions';
import { GenericResponseModel } from '../../dataModel/authModels';
import { appointments } from '../../services/appointments';



export function* getAppointmentSaga() {
  try {
    yield takeLatest(TYPES.GET_CLIENT_APPOINTMENTS, getAppointmentWorker);
  } catch (err) {
  }
}

function* getAppointmentWorker(param:any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield appointments.getAppointmentList();
    yield put(saveClientAppointments(response.resultData));
    yield put(loaderAction(false));
  }catch(e){
  }
}


